import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledValidityContainer = styled(Stack)({
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: '4px',
});
